import 'scripts';
import { createRoot } from 'react-dom/client';
import '_legacy/misc.scss';
import 'modules/themes/default.scss';
import './index.scss';
import { setup } from 'setup';
import App from 'App';

setup();

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(<App />);
